export const accessFeatureConstants = {
    CHECK_ACCESS_FEATURE_REQUEST: 'CHECK_ACCESS_FEATURE_REQUEST',
    CHECK_ACCESS_FEATURE_SUCCESS: 'CHECK_ACCESS_FEATURE_SUCCESS',
    CHECK_ACCESS_FEATURE_FAILURE: 'CHECK_ACCESS_FEATURE_FAILURE',
    
};
